import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import axios from 'axios';

import i18n from "@/helpers/i18n";
import {uuid} from "vue-uuid";

export interface Company {
    _id: string,
    title: string,
    _show: string,
    description: string | null,
    contacts: any[],
    locations: any[],
    promo: any[],
    eventCode: string,
    showCode: string,
    eventTitle: string,
    showTitle: string,
    standTitleObjects: object,
    accountExists: boolean,
    plan: string,
    status: string,
    comment: any
}

export interface State {
    company: any | null,
    companies: [],
    loading: boolean,
    countCompanies: number,
    companiesForMerge: [],
}

const defaultState: State = {
    company: null,
    loading: false,
    companies: [],
    countCompanies: 0,
    companiesForMerge: []
};

const getters = {
    loading: (state: State) => state.loading,
    company: (state: State) => state.company,
    companies: (state: State) => state.companies,
    countCompanies: (state: State) => state.countCompanies,
    companiesForMerge: (state: State) => state.companiesForMerge,
}

const mutations: MutationTree<State> = {
    setCompany(state: State, payload: any) {

        let p = JSON.parse(JSON.stringify(payload))
        payload.locations = p.locations.map((location: any) => {
            let id = location.idType || uuid.v4() + 'address'
            return { ...location, type: 'address', value: location.address, idType: id }
        })
        payload.contacts = payload.contacts.map((contact: any) => {
            let id = contact.idType || uuid.v4() + contact.type
            return {...contact, idType: id}
        })
        state.company = payload
    },
    setCompanies(state: State, payload: any) {
        payload.models.map((company: any, index: number) => company.selected = index == 0 )
        state.companies = payload.models
        state.countCompanies = payload.allCount
    },
    setLoadStatus(state: State, payload: boolean) {
        state.loading = payload
    },
    setAccountExists(state: State) {
        if (state.company) state.company.accountExists = true
    },
    setCompaniesForMerge(state: State, payload: any) {
        state.companiesForMerge = payload.participants
    }
}

const actions: ActionTree<State, RootState> = {
    async loadCompanyFromServer({commit, state}, payload: string) {
        commit('setLoadStatus', true)
        try {
            const {data} = await axios.get('/v5/company/show/participant/' + payload + '?expand=plan,status')
            if (data.status === 'err' && data.errors.length) {
                this.commit('alerts/setAlert', {
                    show: true,
                    messages: data.errors[0].messages
                })
            }
            commit('setCompany', data.data.showCompanyParticipant)
            commit('setLoadStatus', false)
        } catch (e) {
            console.warn(e.message)
            commit('setLoadStatus', false)
        }
    },
    async editCompanyFromServer({commit, state}, payload: any) {
        const id = payload.id
        const params = payload.params
        try {
            const {data} = await axios.patch('v5/company/show/participant/' + id + '?expand=plan,status', params)
            commit('setCompany', data.data.showCompanyParticipant)
            this.commit('alerts/setAlert', {
                show: true,
                color: 'green',
                messages: [i18n.t('company.notifications.save_success')]
            })
            return true
        } catch (e) {
            return false

        }
    },
    async editCompanyPlanFromServer({commit, state}, payload: any) {
        const id = payload.id
        const params = payload.params
        try {
            const {data} = await axios.patch(`/v5/admin/show-company-participant/${id}/plan/change`, params)
            if (state.company) {
                state.company.plan = params.plan
                state.company.status = params.status
                state.company.comment = {}
                state.company.comment.text = params.comment
                state.company.comment.timestamp = data.data.participant.metadata.createdAt
            }
            this.commit('alerts/setAlert', {
                show: true,
                color: 'green',
                messages: [i18n.t('company.notifications.save_success')]
            })
            return true
        } catch (e) {
            return false

        }
    },
    async loadAllCompaniesFromServer({commit, state}, payload: any) {
        try {
            const {data} = await axios.get('/v5/admin/company' +
                '?search=' + payload.search +
                '&' + payload.searchBy +
                '&hasParticipation=0' +
                '&page=' + payload.page +
                '&per-page=' + payload.itemsPerPage)
            commit('setCompanies', data.data)
            return true
        } catch (e) {
            return false
        }
    },
    async addNewCompanyFromServer({commit, state}, payload: any) {
        try {
           await axios.post('/v5/admin/company/' + payload.company + '/show/' + payload.show + '/participant/join', payload.params)
            return {status:true}
        } catch (e) {
            return  {
                status:false,
                mes:e.response.data.error
            }
        }
    },
    async loadCompanyForMerge({commit, state}, payload: any) {
        try {
            const {data} = await axios.get('/v5/admin/company/show/participant?showCode=' + payload)
            commit('setCompaniesForMerge', data.data)
            return true
        } catch (e) {
            return false
        }
    },
    async mergeCompaniesFromServer({commit, state}, payload: any) {
        try {
           await axios.post(`/v5/admin/company/show/participant/${payload.org}/merge/${payload.leadfrog}`, payload.params)
            return true
        } catch (e) {
            return false
        }
    },
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
